import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useContext } from "react";
import { Table } from "react-bootstrap";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import { serverInfo } from "../../../App";
import noImage from "../../../assets/images/settings/no-image.png";
import AuditionApproveFilterVideo from "../../AuditionAdmin/AuditonRounds/AuditionApproveFilterVideo";
import HeaderTitle from "../Auditon-comp/HeaderTitle";
import ManiBanner from "../Auditon-comp/MainBanner";
import SubHeaderTitle from "../Auditon-comp/SubHeaderTitle";
import AuditionIncrementDecrement from "./AuditionIncrementDecrement";
import "./AuditionVideoResult.css";
import TablePaginationReuse from "./TablePaginationReuse";

function AuditionVideoResult({
  videoType,
  audition,
  roundInfo,
  roundUsersb,
  roundUsersc,
  secondaryJuryGroup,
  mainJury,
  isVideoAlreadyAssignedRan,
  setIsVideoAlreadyAssignedRan,
  isVideoAlreadyAssignedPer,
  setIsVideoAlreadyAssignedPer,
}) {
  const { imageCdnUrl } = useContext(serverInfo);

  const [distributedVideoArray, setDistributedVideoArray] = useState([]);
  const [randomDistributedArray, setRandomDistributedArray] = useState([]);

  const [isPercentage, setIsPercentage] = useState(false);
  const [isRandom, setIsRandom] = useState(false);

  const [percentageVideos, setPercentageVideos] = useState([]);
  const [randomVideos, setRandomVideos] = useState([]);
  const [whice, setWhice] = useState("");
  const [perValue, setPerValue] = useState("");

  const handlePercentageVideo = (value) => {
    axios
      .get(
        `/api/audition-admin/audition/get-jury-percentage-videos/${audition.id}/${roundInfo.id}/${value}/${videoType}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          setRandomVideos(res.data.percentage_videos);
          setIsRandom(true);
          setWhice(res.data.whice);
          setPerValue(value);

          let total_jury = mainJury.length;
          let total_video = res.data.percentage_videos.length;

          let videoPackArray = [];
          if (total_jury > 0) {
            let video_pack = Math.floor(total_video / total_jury);
            for (total_jury; total_jury > 0; total_jury--) {
              if (total_jury == 1) {
                videoPackArray.push(total_video);
              } else {
                videoPackArray.push(video_pack);
                total_video = total_video - video_pack;
              }
            }
          }

          setRandomDistributedArray(videoPackArray);
        }
      });
  };

  const handleRandomVideo = (value) => {
    axios
      .get(
        `/api/audition-admin/audition/get-jury-random-videos/${audition.id}/${roundInfo.id}/${value}/${videoType}`
      )
      .then((res) => {
        if (res.data.status === 200) {
          
          setRandomVideos(res.data.random_videos);
          setIsRandom(true);
          setWhice(res.data.whice);
          setPerValue(value);

          let total_jury = mainJury.length;
          let total_video = res.data.random_videos.length;

          let videoPackArray = [];
          if (total_jury > 0) {
            let video_pack = Math.floor(total_video / total_jury);
            for (total_jury; total_jury > 0; total_jury--) {
              if (total_jury == 1) {
                videoPackArray.push(total_video);
              } else {
                videoPackArray.push(video_pack);
                total_video = total_video - video_pack;
              }
            }
          }
          setRandomDistributedArray(videoPackArray);
        }
      });
  };

  const handleApplyForJury = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("audition_id", audition?.id);
    formData.append("round_info_id", roundInfo?.id);
    formData.append("value", perValue);
    formData.append("type", videoType);

    mainJury.forEach((jury) => {
      formData.append("juries[]", jury?.user.id);
    });

    randomDistributedArray.forEach((random) => {
      formData.append("random_videos[]", random);
    });

    if (whice == "p") {
      axios
        .post(
          `/api/audition-admin/audition/assign-main-juries-for-percentage`,
          formData
        )
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setIsVideoAlreadyAssignedPer(true);
          } else {
            swal("Opps...", res.data.message, "error");
          }
        });
    } else if (whice == "r") {
      axios
        .post(`/api/audition-admin/audition/assign-main-juries`, formData)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            setIsVideoAlreadyAssignedRan(true);
          } else {
            swal("Opps...", res.data.message, "error");
          }
        });
    }
  };

  const tableHead = ["Name", "Email", "Videos"];

  return (
    <div className="row">
      <HeaderTitle title={audition.title} />

      <SubHeaderTitle title="Time Duration" />

      {/* <ManiBanner
        title={`ROUND ${
          roundInfo.round_num
        } Jury Or Judge Mark TIME DURATION ${moment(
          roundInfo.jury_or_judge_mark_start_date
        ).format("LL")} - ${moment(
          roundInfo.jury_or_judge_mark_end_date
        ).format("LL")}`}
      /> */}

      <div className="img-bgImg my-4 p-3 rounded-3">
        <h3 className="text-center text-white withText">{`ROUND ${roundInfo.round_num}`}</h3>

        <h4 className="d-flex justify-content-center text-light">
          Jury Or Judge mark time duration
        </h4>
        <center className="my-4">
          <div className="col-md-5">
            <h5 className="head-line py-3 card-text lead text-light">
              {moment(roundInfo.jury_or_judge_mark_start_date).format("LL")} -
              {moment(roundInfo.jury_or_judge_mark_end_date).format("LL")}
            </h5>
          </div>
        </center>
      </div>

      <div className="my-3">
        <HeaderTitle title={`Audition Round ${roundInfo.round_num}`} />
      </div>
      <SubHeaderTitle title="Total Videos" />

      {Object.keys(secondaryJuryGroup).map((item, i) => (
        <div key={i} className="my-5">
          <HeaderTitle
            title={`Round ${roundInfo.round_num} - Jury Result (Group ${
              Object.values(secondaryJuryGroup)[i][0]?.jury_group?.name
            })`}
          />

          {i === 0 ? (
            <>
              <TablePaginationReuse isJuryB={true} tableHead={tableHead} data={roundUsersb} />
            </>
          ) : (
            <>
              <TablePaginationReuse isJuryB={false} tableHead={tableHead} data={roundUsersc} />
            </>
          )}
        </div>
      ))}

      <AuditionIncrementDecrement
        btn1="Select Percentage"
        btn2="Difference between B & C"
        btn3="% mark gained user for the next round"
        handleOnClick={handlePercentageVideo}
      />

      <div className="my-3">
        <AuditionIncrementDecrement
          btn1="Select Random"
          btn2="Random Videos From B & C"
          btn3="Random Videos for Next Round"
          handleOnClick={handleRandomVideo}
        />
      </div>

      {isRandom ? (
        <>
          <div className="row">
            <AuditionApproveFilterVideo data={randomVideos} />
          </div>

          <div key={0} className="StarAdminBc">
            <div className="d-flex justify-content-between align-items-center MoBds">
              <div className=" text-light p-3 GroupHeader mb-3">
                <h5>Group A</h5>
              </div>
              <div className=" p-3 GroupHeaderS mb-3">
                <h5>Auto Assign</h5>
              </div>
            </div>
            <center className="row justify-content-center align-items-center my-4 p-3">
              {mainJury.map((jury, index) => (
                <div key={index} className="col-md-4 mb-5 ">
                  <div className="BXCStar  pb-3 mb-3">
                    <center>
                      <img
                        src={
                          jury?.user?.image != null
                            ? imageCdnUrl + jury?.user?.image
                            : noImage
                        }
                        alt="JuryImage"
                        width={120}
                        height={120}
                        style={{ borderRadius: "50%" }}
                        className="my-3"
                      />
                      <h4 className="text-light">
                        {jury?.user?.first_name} {jury?.user?.last_name}
                      </h4>
                      <h6 className="TextNX">{jury?.user?.category.name} </h6>
                      <h6 className="TextNX mb-4">Specialist</h6>
                      <div className="d-flex DBtv justify-content-center ">
                        {randomDistributedArray.length > 0 ? (
                          <>
                            {whice === "r" ? (
                              <>
                                {isVideoAlreadyAssignedRan ? (
                                  <>
                                    <input
                                      readOnly
                                      type="text"
                                      className="from-control RoundVr p-2"
                                      value="Already Assigned"
                                    />
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      readOnly
                                      className="from-control RoundVr p-2"
                                      onChange={(e) =>
                                        setRandomDistributedArray([
                                          (randomDistributedArray[index] =
                                            Number(e.target.value)),
                                        ])
                                      }
                                      value={
                                        randomDistributedArray.length > 0 &&
                                        randomDistributedArray[index]
                                      }
                                    />
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {isVideoAlreadyAssignedPer ? (
                                  <>
                                    <input
                                      readOnly
                                      type="text"
                                      className="from-control RoundVr p-2"
                                      value="Already Assigned"
                                    />
                                  </>
                                ) : (
                                  <>
                                    <input
                                      type="text"
                                      readOnly
                                      className="from-control RoundVr p-2"
                                      onChange={(e) =>
                                        setRandomDistributedArray([
                                          (randomDistributedArray[index] =
                                            Number(e.target.value)),
                                        ])
                                      }
                                      value={
                                        randomDistributedArray.length > 0 &&
                                        randomDistributedArray[index]
                                      }
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </div>
                    </center>
                  </div>
                </div>
              ))}
            </center>
            <center>
              <>
                {whice === "r" ? (
                  <>
                    {isVideoAlreadyAssignedRan ? (
                      <>
                        <button className="btn border-success text-success p-2 my-5">
                          Already Assigned!
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          disabled={false}
                          onClick={(e) => handleApplyForJury(e)}
                          className="btn btnWe fw-bold BntIu p-2 my-5"
                        >
                          Apply For Jury
                        </button>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {isVideoAlreadyAssignedPer ? (
                      <>
                        <button className="btn border-success text-success p-2 my-5">
                          Already Assigned!
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          disabled={false}
                          onClick={(e) => handleApplyForJury(e)}
                          className="btn btnWe fw-bold BntIu p-2 my-5"
                        >
                          Apply For Jury
                        </button>
                      </>
                    )}
                  </>
                )}
              </>
            </center>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

export default AuditionVideoResult;
